import React from 'react';
import CommonPage from '../../components/CommonPage';
const pageType = "AGENT";

function AgentApp(props) {
    return <CommonPage pageType={pageType} />;
}

export default AgentApp;